export default __webpack_public_path__ + "static/media/Overlays_take5.dcd2d83c.png";